import { PillColor } from './pill-color';

export enum ObjectStatusColor {
  DRAFT = PillColor.GREEN,
  PUBLISHED = PillColor.BLUE,
}
